export const sanitizeCpf = (value: string): string =>
	String(value || '').replace(/\D/g, '');

export const maskCpf = (value: string): string => {
	const digits = sanitizeCpf(value).slice(0, 11);
	return digits
		.replace(/(\d{3})(\d)/, '$1.$2')
		.replace(/(\d{3})(\d)/, '$1.$2')
		.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

export const isValidCpf = (value: string): boolean => {
	const digits = sanitizeCpf(value);

	if (digits.length !== 11) return false;
	if (/^(\d)\1{10}$/.test(digits)) return false;

	const numbers = digits.split('').map(Number);

	let sum = 0;
	for (let i = 0; i < 9; i++) sum += numbers[i] * (10 - i);
	let check = (sum * 10) % 11;
	if (check === 10) check = 0;
	if (check !== numbers[9]) return false;

	sum = 0;
	for (let i = 0; i < 10; i++) sum += numbers[i] * (11 - i);
	check = (sum * 10) % 11;
	if (check === 10) check = 0;
	if (check !== numbers[10]) return false;

	return true;
};
